import styled from "styled-components";
import monitor from "../../img/icons/pc.png";
import targetArrow from "../../img/icons/target-arrow.png";
import pallete from "../../img/icons/raphael_pallete.png";
import search from "../../img/icons/search-web.png";
import {FaLongArrowAltRight} from "react-icons/fa";
import Fade from 'react-reveal/Fade';

function Service(props){
    return(
        <Serv className={props.type}>
            <div className="layout-serv">
                <Icon>
                    <img
                        src={props.img}
                        alt={props.altImg}
                    />

                </Icon>
                <Text>
                    {props.text}
                </Text>
                <Link className={props.type}>
                    <a
                        href={props.link}
                    >
                        <div>
                            Zjistit více
                        </div>
                        <FaLongArrowAltRight />
                    </a>
                </Link>
            </div>
        </Serv>
    );
}
const Serv = styled.div `
  position:relative;
  
  width: 280px;
  height: 350px;
  
  border-radius: 20px;
  .layout-serv{
    padding:24px;
    height: 86%;
  }
  @media only screen and (min-width: 899px) and (max-width: 1360px){
    flex: 0 0 48%;
    .layout-serv{
      padding:36px 36px 36px 36px;
    }
  }
  @media only screen and (max-width: 899px){
    width: auto;
    height: 280px;
    margin-bottom:30px;
    .layout-serv{
      padding:40px;
    }
  }
`;
const Icon= styled.div`
  width:24px;
  padding-bottom:10px;
` ;
const Text = styled.div`
  font-weight: bold;
  font-size:26px;
`;
const Link = styled.div`
  position:absolute;
  bottom: 24px;
  left: 50%;
  transform: translate(-50%, -50%);
  
  
  a{
    text-decoration: none;
    font-weight: bold;
    font-size:18px;
    display:flex;
    align-items: center;
  }
  svg{
    padding-left:10px;
    font-size:24px;
  }
`;
function Services(){

    return(
        <div>
            <Title className="h-1 title-padding-2-bottom">
                Služby, které Vám nabízíme
            </Title>
            <Flex>
                <Fade bottom duration={1200}>
                    <Service link="blog/vyvoj-webovych-stranek" type="Service-red" text="Vývoj webových stránek a aplikací"  img={monitor} altImg=""/>
                </Fade>
                <Fade bottom duration={1600}>
                    <Service link="blog/marketing-seo" type="Service-red" text="Marketing a SEO" img={targetArrow} altImg=""/>
                </Fade>
                <Fade bottom duration={2000}>
                    <Service link="blog/graficky-design" type="Service-red" text="Grafický design" img={pallete} altImg=""/>
                </Fade>
                <Fade bottom duration={2400}>
                    <Service link="blog/startup" type="Service-white" text="Pro Startupy"  img={search} altImg="" />
                </Fade>
            </Flex>
        </div>
    );
}
const Title = styled.div`
  color:#4F4F4F;
`;
const Flex = styled.div `
  display:flex;
  justify-content: center;
  gap:30px;
  @media only screen and (min-width: 899px) and (max-width: 1360px){
    flex-wrap:wrap;
  }
  @media only screen and (max-width: 899px){
    display:block;
  }
`;
export default Services;